export const setChatNotificationData = (data, action) => ({
  type: 'SET_CHAT_NOTIFICATION_DATA',
  payload: { data, action },
});

export const setFilterNotificationData = (data, action) => ({
  type: 'FILTER_NOTIFICATION_DATA',
  payload: { data, action },
});

export const resetChatNotificationData = () => ({
  type: 'RESET_CHAT_NOTIFICATION_DATA',
});
